import Vue from 'vue'
import Vuex from 'vuex'

import geolocation from '../modules/geolocation/store'
import quote from '../modules/quote/store'
import library from '../modules/library/store'
import systemOption from '../modules/systemoptions/store'
import authentication from '../modules/authentication/store'
import authorization from '../modules/authorization/store'
import location from '../modules/location/store'
import admin from '../modules/admin/store'
import stats from '../modules/stats/store'

import Composite from '../Composite'
import event from '../event'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    geolocation: { ...geolocation, namespaced: true },
    location: { ...location, namespaced: true },
    quote: { ...quote, namespaced: true },
    library: { ...library, namespaced: true },
    systemOption: { ...systemOption, namespaced: true },
    authentication: { ...authentication, namespaced: true },
    authorization: { ...authorization, namespaced: true },
    admin: { ...admin, namespaced: true },
    stats: { ...stats, namespaced: true }
  },
  actions: {
    initAuth ({commit, dispatch}, data) {
      return new Promise((resolve, reject) => {
        dispatch('authentication/initialise')
          .then((isLoggedIn) => {
            resolve()
          })
          .catch((notLoggedInOrError) => {
            reject()
          })
      })
    },
    initialiseQuoteForm ({commit, dispatch}, data) {
      dispatch('quote/loadFormData')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js